import { SITE } from "../config/site";

export const PromoBar = () => (
  <div
    data-testid="promo-bar"
    className="bg-gradient-to-r from-amber-400 via-amber-500 to-orange-500 text-white text-center px-4 py-2"
  >
    <p className="text-[11px] sm:text-xs font-bold tracking-[0.14em] uppercase">{SITE.promoText}</p>
  </div>
);
